import { simulationService } from "@/api/simulationService";
import { usePaginatedResource } from "@/hooks/usePaginatedResource";
import type { simulation } from "../dashboard/types.api";
import type { simulationFormData } from "../userManagement/components/userFormModal/types.props";
import type { simulationFilters } from "./types.props";


const defaultFilters: simulationFilters = { search: "" };
export const useSimulations = () =>
    usePaginatedResource<simulation, simulationFilters, simulationFormData>(
        simulationService,
        defaultFilters,
    );
